export default __webpack_public_path__ + "static/media/flyins-logo.68601337.svg";